import angular from 'angular';

import component from './siteVersionLabel.component';
import appVersionServiceModule from '../../service/AppVersionService';

let module = angular.module('recaps.components.siteVersionLabel', [
  appVersionServiceModule.name,
]);

module.component('siteVersionLabel', component);

export default module;
